import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

const WishSelect = ({ label, data = [], dataKey = "id", dataValue = "title_name", onSelect, initialValue, id, placeholder = false, error, required = false }) => {
  const elementId = id ? id : label ? label?.replace(" ", "") : uuidv4();

  const [selectedItem, setSelectedItem] = useState(initialValue ?? data[0]);

  useEffect(() => {
    setSelectedItem(initialValue);
  }, [initialValue]);

  return (
    <div className={"form-group row" + (error ? " align-items-start" : " d-flex align-items-center")}>
      <div className={"" + (label !== undefined ? " col-md-3 col-lg-3 col-sm-12 " : " hidden ")}>
        <label htmlFor={elementId} className="text-capitalize">
          {label}
          {required ? <span className="text-danger"> *</span> : null}
        </label>
      </div>
      <div className={"" + (label !== undefined ? " col-lg-9 col-md-9 col-sm-12 " : " col-12 ")}>
        <select
          id={elementId}
          name={elementId}
          className={"form-control" + (error ? " is-invalid" : "")}
          // defaultValue={selectedItem}
          // value={selectedItem}
          onChange={(e) => {
            setSelectedItem(e.target.value);
            onSelect && onSelect(e.target.value);
          }}
          value={selectedItem}
        >
          {placeholder ? (
            <option selected value={""}>
              Choose...
            </option>
          ) : null}
          {data &&
            data.map((item, index) => {
              return (
                <option
                  value={item[dataKey]}
                  key={index}
                  //selected={item === selectedItem ? "selected" : ""}
                >
                  {item[dataValue]}
                </option>
              );
            })}
        </select>
        {error ? <small className="text-danger d-block mt-1">{error}</small> : null}
      </div>
    </div>
  );
};

export default WishSelect;
